// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, string } from 'prop-types'

const PassiveRow = ({ antennas, idRoot, latitude, longitude, siteName }) => (
  <dd className={'additional-tooltip-separator'}>
    <ul>
      <li>
        <span className={'uppercase'}>{'Site Name'}</span>
        <span id={`${idRoot}site-name`}>{siteName}</span>
      </li>
      <li>
        <span className={'uppercase'}>{'Latitude'}</span>
        <span id={`${idRoot}latitude`}>{latitude}</span>
      </li>
      <li>
        <span className={'uppercase'}>{'Longitude'}</span>
        <span id={`${idRoot}longitude`}>{longitude}</span>
      </li>
      <li>
        <span className={'uppercase'}>
          {`Antenna${antennas.length > 1 ? 's' : ''}`}
        </span>
        <div style={{textAlign: 'right'}}>
          {antennas.map((d, i) =>
            <p
              key={i}
              id={`${idRoot}antenna-${i}`}
              title={`Antenna Code ${d.antennaCode}`}>
              {d.modelNumber}
            </p>
          )}
        </div>
      </li>
    </ul>
  </dd>
)

PassiveRow.propTypes = {
  antennas: array.isRequired,
  idRoot: string.isRequired,
  latitude: string.isRequired,
  longitude: string.isRequired,
  siteName: string.isRequired,
}

export default PassiveRow
